import React, { useState } from "react";
import SelectorComponent from "./balanceWallet/SelectorComponent";
import DisplayComponent from "./balanceWallet/DisplayComponent";
import { useGetPaymentQuery } from "../apis/PaymentMethodApi";
import { getUserData } from "../auth";
import { useGetBalanceQuery } from "../apis/BalanceApi";
  
const BalanceWalletAmazon = () => {
  const [selectedItem, setSelectedItem] = useState(null);
  
  const userData = getUserData();
  const userId = userData?.uid || "";
//  const { data: balanceData, isLoading:isLoadingBalance, error:errorBalance } = useGetBalanceQuery(userId);
const { data: balanceData, isLoading: isLoadingBalance, error: errorBalance } = useGetBalanceQuery(userId, { pollingInterval: 5000 });
  
// Fetch data from PaymentApi using the useGetPaymentQuery hook
  const { data: paymentData, isLoading, error } = useGetPaymentQuery();

  // This is a fallback or a mock of the wallet items in case the API call fails
  const items = paymentData ? paymentData : [
    {
      id: 1,
      name: " ",
      walletAdress: " ",
      imageUrl: " ",
    }, 
  ];
  const myBalance = balanceData ? balanceData :
  {
    id: 0,
    balance:0
  }
  const handleItemSelected = (item) => {
    setSelectedItem(item);
  };

  if (isLoading && isLoadingBalance) {
    return <div>Loading...</div>;
  }
 

  if (errorBalance) {
    return <div>Error loading Balance</div>;
  }
  if (error) {
    return <div>Error loading wallet Info</div>;
  }

  return (
    <section className="account py-15">
      <div className="container container-lg">
        <div className="row gy-4">
          {/* Pass the fetched items to the SelectorComponent */}
          <SelectorComponent items={items} onItemSelected={handleItemSelected} Balance={myBalance?.balance} />
          {/* Display the selected item in DisplayComponent */}
          <DisplayComponent selectedItem={selectedItem} Balance={myBalance?.balance} />
        </div>
      </div>
    </section>
  );
};

export default BalanceWalletAmazon;
